export const locale = {
    lang: 'es',
    data: {
        'lbl' : {
            'logout': 'Salida Segura'
        }
    }
};
